export default __webpack_public_path__ + "static/media/learn-from-users-arrow-mobile.c1063d96.svg";